/*eslint no-unused-vars: ["error", { "varsIgnorePattern": "[iF]ragment" }]*/

import React from "react"
import { useStaticQuery, graphql } from "gatsby"
import {
  SiteVariablesFragment,
  ListingsRenovationsPageFragment,
  PropertyFragment,
} from "src/components/QueryFragments"

import "src/assets/scss/material-kit-react.scss"

import ListingsView from "../views/ListingsView"

const ListingsActivePage = ({ location }) => {
  const {
    contentfulWebsiteGlobalVariables,
    contentfulPageRenovations,
    allContentfulProperty,
  } = useStaticQuery(
    graphql`
      query {
        contentfulWebsiteGlobalVariables {
          ...SiteVariablesFragment
        }
        contentfulPageRenovations {
          ...ListingsRenovationsPageFragment
        }
        allContentfulProperty(
          filter: { boolean_remodel: { eq: true } }
          sort: { fields: date_closing, order: DESC }
        ) {
          nodes {
            ...PropertyFragment
          }
        }
      }
    `
  )

  return (
    <ListingsView
      siteVariables={contentfulWebsiteGlobalVariables}
      pageContent={contentfulPageRenovations}
      properties={allContentfulProperty.nodes}
      listingType="renovation"
      location={location}
    />
  )
}

export default ListingsActivePage
